define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.resolvePluginAccountId = void 0;
    const resolvePluginAccountId = (environment, accountId) => {
        var _a, _b;
        return (environment === null || environment === void 0 ? void 0 : environment.name) === "occ" && !((_b = (_a = environment.features) === null || _a === void 0 ? void 0 : _a.switchCompany) === null || _b === void 0 ? void 0 : _b.enabled)
            ? undefined
            : accountId;
    };
    exports.resolvePluginAccountId = resolvePluginAccountId;
});
